/* Carries the query parameters the visitor landed with onto every link.

   Everything in the landing URL is forwarded as-is - utm_*, tw_*, tblci,
   gclid, li_did, whatever a network happens to send. Nothing is filtered.

   Links are decorated once the DOM is ready, and again the moment one is
   clicked, so a link that some other script rewrote in between still leaves
   with the parameters. Applying twice is harmless: a parameter is written
   with set(), so it is replaced rather than appended again. */

var UTM_LANDING_QUERY = window.location.search;

function utmIsSkippedHref(href) {
  if (!href) return true;
  if (href.charAt(0) === "#") return true;

  var scheme = href.slice(0, 11).toLowerCase();

  return (
    scheme.indexOf("mailto:") === 0 ||
    scheme.indexOf("tel:") === 0 ||
    scheme.indexOf("javascript:") === 0
  );
}

function utmApplyToLink(link) {
  var href = link.getAttribute("href");

  if (utmIsSkippedHref(href)) return;

  var url;

  try {
    url = new URL(href, window.location.href);
  } catch (error) {
    return;
  }

  if (url.protocol !== "http:" && url.protocol !== "https:") return;

  var changed = false;

  new URLSearchParams(UTM_LANDING_QUERY).forEach(function (value, key) {
    if (url.searchParams.get(key) === value) return;
    url.searchParams.set(key, value);
    changed = true;
  });

  if (changed) link.setAttribute("href", url.toString());
}

function utmApplyToAllLinks() {
  var links = document.querySelectorAll("a[href]");

  for (var i = 0; i < links.length; i++) {
    utmApplyToLink(links[i]);
  }
}

function utmHandleClick(event) {
  var target = event.target;

  if (!target || typeof target.closest !== "function") return;

  var link = target.closest("a[href]");

  if (link) utmApplyToLink(link);
}

function utmInit() {
  if (!UTM_LANDING_QUERY) return;

  utmApplyToAllLinks();

  document.addEventListener("click", utmHandleClick, true);
  document.addEventListener("auxclick", utmHandleClick, true);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", utmInit);
} else {
  utmInit();
}
